import { Component } from 'react';
import * as Sentry from '@sentry/browser';

import ErrorPage from 'components/ErrorPage';


class ErrorBoundary extends Component {
    state = {
        eventId: '',
        error: '',
        errorInfo: '',
        hasError: false,
    };
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, info) {
        console.log(error, info);
        this.setState({ error: true });
        const ignoreList = ['ChunkLoadError'];
        const { user } = this.props;

        if (user?.id) {
            Sentry.setUser({
                id: user.id,
                segment: user.role,
            });
        }

        if (ignoreList.indexOf(error.name) < 0) {
            Sentry.withScope(scope => {
                scope.setExtras(info);
                const eventId = Sentry.captureException(error);
                // captureExceptions returns eventId
                // could do something with this (i.e. add a report feedback feature, see:
                // https://docs.sentry.io/platforms/javascript/react/
                this.setState({ eventId, info});
            });
        }
    }
    renderError() {
        if (this.props.renderFallback) {
            return this.props.renderFallback();
        }
        return <ErrorPage />;
    }
    render() {
        const { children } = this.props;
        const { error } = this.state;

        if (error) {
            return this.renderError();
        }

        return children;
    }
}

export default ErrorBoundary;
